import type { QueryClient } from '@tanstack/react-query';
import { SIDECAR_ROUTES } from 'src/sidecar-routes.enum';
import type { SidecarRoute } from '$components/sidecar-router/sidecar-router.definitions';
import { OrganizationDetail } from '$features/organizations/detail/detail-tab/organization-detail';
import { OrganizationDevicesLogs } from '$features/organizations/detail/logs-tab/organization-devices-logs';
import { OrganizationDetailPage } from '$pages/organization-management/detail/organization-detail-page';

export function createSidecarRoutes(_queryClient: QueryClient): Record<SIDECAR_ROUTES, SidecarRoute> {
  return {
    [SIDECAR_ROUTES.Organization]: {
      element: <OrganizationDetailPage />,
      children: {
        info: {
          element: <OrganizationDetail />,
        },
        logs: {
          element: <OrganizationDevicesLogs />,
        },
      },
    },
  };
}
